import { gql } from '@apollo/client';

const DELETE_EVENT_COMMENT = gql`
  mutation DeleteEventComment($id: Int!) {
    deleteEventComment(id: $id)
  }
`;

export default DELETE_EVENT_COMMENT;
